import { alpha, createTheme } from "@mui/material/styles";
import { checkboxClasses } from "@mui/material/Checkbox";
import { radioClasses } from "@mui/material/Radio";

/**
 * Creates a theme based on the user's preference
 *
 * @param {string} mode - The theme mode, either "dark" or "light"
 * @returns {Object} The theme object
 */
const evokeTheme = (mode = "light") => {
  return createTheme({
    palette: {
      type: mode,
      primary: {
        light: mode === "light" ? "#414042" : "#e9eaf4",
        main: mode === "light" ? "#414042" : "#e9eaf4",
        contrastText: mode === "light" ? "#fff" : "#000",
      },
      secondary: {
        main: "#94BA33",
        contrastText: "#fff",
        disabled: alpha("#94BA33", 0.3),
      },
      action: {
        disabledBackground: alpha("#94BA33", 0.3),
      },
      error: {
        main: "#f44336",
        contrastText: "#fff",
      },
      background: {
        default: mode === "light" ? "#f5f5f5" : "#1E1F21",
        paper: mode === "light" ? "#ffffff" : "#252525",
      },
      border: {
        main: mode === "light" ? "#E0E0E0" : "#ffffff",
        contrastText: mode === "light" ? "#000000" : "#ffffff",
      },
      lightText: {
        main: mode === "light" ? "#757575" : "#fff",
      },
    },
    typography: {
      useNextVariants: true,
    },
    components: {
      MuiAppBar: {
        defaultProps: {
          color: "inherit",
        },
      },
      MuiButton: {
        defaultProps: {
          color: "inherit",
        },
      },
      MuiGrid: {
        styleOverrides: {
          root: {
            marginTop: 0,
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: "14px",
            fontWeight: "400",
            color: "#444444",
            backgroundColor: "#FFFFFF !important",
            boxShadow: "0px 8px 20px -5px rgba(40, 40, 40, 0.3)",
            borderRadius: "4px",
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          regular: {
            minHeight: "74px !important",
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          colorPrimary: {
            "&.Mui-checked": {
              color: "#94BA33",
            },
          },
          track: {
            ".Mui-checked.Mui-checked + &": {
              opacity: 0.7,
              backgroundColor: "#94BA33",
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          colorPrimary: {
            [`&.${radioClasses.checked}`]: {
              color: "#94BA33",
            },
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          colorPrimary: {
            [`&.${checkboxClasses.checked}`]: {
              color: "#94BA33",
            },
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            paddingTop: "5px !important",
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            marginLeft: 0,
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#94BA33",
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          deleteIcon: {
            color: "#757575",
            backgroundColor: "transparent",
            borderRadius: "50%",
            padding: "2px",
            ":hover": {
              backgroundColor: "#F5F5F5",
            },
          },
        },
      },
    },
  });
};

export default evokeTheme;
